import actions from './actions';

const initialState = {
    pedidosOnline: [],
    paginationInfo: {},
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_PEDIDOS_ONLINE_SUCCESS:
            return {
                ...state,
                pedidosOnline: action.payload,
            }
        case actions.SET_PAGINATION_INFO:
            return {
                ...state,
                paginationInfo: action.payload,
            };
        default:
            return state;
    }

}
